import React, { useState, useEffect } from 'react';

export default function HaikuNotizEditor({ berichtId, initialNotiz, onSave }) {
    const [notiz, setNotiz] = useState(initialNotiz || '');
    const [dirty, setDirty] = useState(false);
    const [saving, setSaving] = useState(false);
    const [savedFlash, setSavedFlash] = useState(false);

    useEffect(() => { setNotiz(initialNotiz || ''); setDirty(false); }, [initialNotiz]);

    async function handleSave() {
        if (!dirty) return;
        setSaving(true);
        await onSave(notiz);
        setSaving(false);
        setDirty(false);
        setSavedFlash(true);
        setTimeout(() => setSavedFlash(false), 1500);
    }

    return (
        <div style={{ marginTop: '10px', padding: '8px 10px', background: '#f0f6ff', borderRadius: '4px', border: '1px solid #d0e0f5' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                <strong style={{ fontSize: '0.82rem', color: '#1a73e8' }}>📝 Eigene Notiz / Entscheidung</strong>
                {savedFlash && <span style={{ fontSize: '0.78rem', color: '#34a853' }}>✓ gespeichert</span>}
            </div>
            <textarea
                value={notiz}
                onChange={e => { setNotiz(e.target.value); setDirty(true); }}
                placeholder="Was hast du entschieden? Welche Maßnahme aus diesem Bericht setzt du um?"
                rows={3}
                style={{
                    width: '100%',
                    fontFamily: 'inherit',
                    fontSize: '0.85rem',
                    padding: '6px 8px',
                    border: '1px solid #c0d0e8',
                    borderRadius: '3px',
                    resize: 'vertical',
                    boxSizing: 'border-box',
                }}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px' }}>
                <span style={{ fontSize: '0.72rem', color: '#5f6368' }}>Bericht-ID: {berichtId}</span>
                <button
                    onClick={handleSave}
                    disabled={!dirty || saving}
                    style={{
                        fontSize: '0.78rem',
                        padding: '4px 10px',
                        background: dirty ? '#1a73e8' : '#9aa0a6',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: dirty ? 'pointer' : 'not-allowed',
                    }}
                >{saving ? 'Speichert…' : 'Speichern'}</button>
            </div>
        </div>
    );
}
